import * as i0 from '@angular/core';
import { Injectable, InjectionToken, NgModule, Inject } from '@angular/core';
import * as i1 from '@ngneat/effects';
import { Actions as Actions$1, isEffect, registerEffects, actions, initEffects, createEffectFn } from '@ngneat/effects';
import { Subject } from 'rxjs';

class Actions extends Actions$1 {
}
Actions.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: Actions, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
Actions.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: Actions, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: Actions, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

const EFFECTS_PROVIDERS = new InjectionToken('EFFECTS_PROVIDERS');
const EFFECTS_MANAGER = new InjectionToken('@ngneat/effects Effects Manager');

class EffectsNgModule {
    constructor(manager, providers, injector) {
        const flattenProviders = flatten(providers);
        flattenProviders.forEach(provider => {
            const instance = injector.get(provider);
            const effects = Object.values(instance).filter((v) => isEffect(v));
            registerEffects(effects);
        });
    }
    static forRoot(providers, config) {
        return {
            ngModule: EffectsNgModule,
            providers: [
                {
                    provide: Actions,
                    useValue: (config === null || config === void 0 ? void 0 : config.customActionsStream) || actions
                },
                {
                    provide: EFFECTS_MANAGER,
                    useFactory: () => initEffects(config)
                },
                ...providers,
                {
                    provide: EFFECTS_PROVIDERS,
                    multi: true,
                    useValue: providers
                }
            ]
        };
    }
    static forFeature(providers) {
        return EffectsNgModule.forRoot(providers);
    }
}
EffectsNgModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: EffectsNgModule, deps: [{ token: EFFECTS_MANAGER }, { token: EFFECTS_PROVIDERS }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.NgModule });
EffectsNgModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: EffectsNgModule });
EffectsNgModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: EffectsNgModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: EffectsNgModule, decorators: [{
            type: NgModule
        }], ctorParameters: function () {
        return [{ type: i1.EffectsManager, decorators: [{
                        type: Inject,
                        args: [EFFECTS_MANAGER]
                    }] }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [EFFECTS_PROVIDERS]
                    }] }, { type: i0.Injector }];
    } });
function flatten(arr) {
    return arr.reduce((acc, cur) => acc.concat(Array.isArray(cur) ? flatten(cur) : cur), []);
}
;

class EffectFn {
    constructor() {
        this.destroy = new Subject();
        this.destroy$ = this.destroy.asObservable();
    }
    createEffectFn(factoryFn) {
        return createEffectFn(factoryFn)(this.destroy$);
    }
    ngOnDestroy() {
        this.destroy.next(true);
    }
}
EffectFn.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: EffectFn, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
EffectFn.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: EffectFn });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: EffectFn, decorators: [{
            type: Injectable
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { Actions, EffectFn, EffectsNgModule };
